import {BaseModel} from './base-model';

export abstract class SelectableModel extends BaseModel {
  selected = false;
}

export function isSelectable(object): object is SelectableModel {
  return typeof (object as SelectableModel).selected !== 'undefined';
}
